export const DRAFT = 'DRAFT';
export const CREATED = 'CREATED';
export const IN_PROGRESS = 'IN_PROGRESS';
export const REVIEW_REQUESTED = 'REVIEW_REQUESTED';
export const ACCEPTED = 'ACCEPTED';
export const PUBLISHED = 'PUBLISHED';
